import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import { getCookieStorage } from '@src/utils/enhancedCookie'

/**
 * Gets Meta pixel tracking cookies (_fbp and _fbc).
 *
 * Both cookies are set by the Meta Pixel script and are advertising identifiers:
 * - _fbp: Meta browser ID (persistent, identifies the browser across sessions)
 * - _fbc: Meta click ID (set when a user clicks a Meta ad)
 *
 * These are forwarded un-hashed in the server_pixel_properties payload so the
 * sGTM Meta CAPI template can populate user_data.fbp / user_data.fbc and
 * improve Event Match Quality (EMQ).
 *
 * Callers MUST gate this function behind an advertising-consent check
 * (e.g. !getIsCountryCompliant()) so it is never invoked for UK/GDPR locales
 * where TrustArc would have already erased these cookies on consent revoke.
 */
export const getMetaTrackingData = (): {
  fbp: string
  fbc: string
} => {
  const cookieStorage = getCookieStorage()
  const fbp = cookieStorage.getCookieLocalized(ANALYTIC_COOKIES.THIRD_PARTY.FACEBOOK_FBP, { isGlobal: true }) ?? ''
  const fbc = cookieStorage.getCookieLocalized(ANALYTIC_COOKIES.THIRD_PARTY.FACEBOOK_FBC, { isGlobal: true }) ?? ''

  return { fbp, fbc }
}
